import React from 'react';
import { Box } from '@mui/material';

type PerspectiveCropperFrameProps = {
  frameSize: { width: number; height: number } | null;
  overlayRef: React.MutableRefObject<HTMLDivElement | null>;
  onPointerDown: (event: React.PointerEvent<HTMLDivElement>) => void;
  onPointerMove: (event: React.PointerEvent<HTMLDivElement>) => void;
  onPointerUp: (event: React.PointerEvent<HTMLDivElement>) => void;
  onPointerLeave: (event: React.PointerEvent<HTMLDivElement>) => void;
};

const PerspectiveCropperFrame: React.FC<PerspectiveCropperFrameProps> = React.memo(({
  frameSize,
  overlayRef,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  onPointerLeave,
}) => {
  if (!frameSize) {
    return null;
  }

  return (
    <Box
      ref={overlayRef}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerLeave={onPointerLeave}
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: frameSize.width,
        height: frameSize.height,
        border: '3px solid',
        borderColor: 'primary.main',
        borderRadius: 1,
        cursor: 'grab',
        boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.5)',
        zIndex: 10,
        touchAction: 'none',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: -2,
          left: -2,
          width: 20,
          height: 20,
          borderTop: '3px solid',
          borderLeft: '3px solid',
          borderColor: 'primary.main',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: -2,
          right: -2,
          width: 20,
          height: 20,
          borderTop: '3px solid',
          borderRight: '3px solid',
          borderColor: 'primary.main',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: -2,
          right: -2,
          width: 20,
          height: 20,
          borderBottom: '3px solid',
          borderRight: '3px solid',
          borderColor: 'primary.main',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: -2,
          left: -2,
          width: 20,
          height: 20,
          borderBottom: '3px solid',
          borderLeft: '3px solid',
          borderColor: 'primary.main',
        }}
      />
    </Box>
  );
});

PerspectiveCropperFrame.displayName = 'PerspectiveCropperFrame';

export default PerspectiveCropperFrame;
